export interface TimeRange {
  start: Date;
  end: Date;
}

export const isTimeWithinRanges = ({
  time,
  ranges,
}: {
  time: Date;
  ranges: TimeRange[];
}): boolean => {
  if (ranges.length === 0) {
    return false;
  }

  return ranges.some((range) => {
    if (range.start <= time && range.end >= time) {
      return true;
    }
    return false;
  });
};
